import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { useAuth } from '../../context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';

export default function ProtectedRoute() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LinearProgress />; 
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
}
